import _ from "lodash";
import React, { useState } from "react";
import classes from "./MultipleAttachmentsSlider.scss";
import { compose } from "lib/apolloClient";
import I18nHOC from "UIComponents/I18nHOC";
import MediaPlaceholder from "UIComponents/MediaPlaceholder";
import SlickSlider from "UIComponents/SlickSlider";
import MediaModal from "UIComponents/MediaModal";
import ScrollableCarousel from "UIComponents/ScrollableCarousel";
import { colors } from "@toddle-edu/ds-theme";
import { showNewTheatreMode } from "Utils/GetTheatreModeType";
import ConditionalWrapper from "Utils/ConditionalWrapper";
import TheatreModeV2 from "UIComponents/TheatreModeV2";
import PostDetail from "Post/routes/PostDetail";
import { MediaCard } from "@toddle-edu/ds-web";
import classNames from "classnames";
import { isNewNotesUi } from "Post/utils";

const renderAttachment = ({
  item,
  index,
  deleteAttachment,
  showDeleteIcon = false,
  mode = "view",
  shouldClickOnMedia,
  onClickMedia,
  cardType,
  attachmentCardStyle = {},
  deleteButtonVariant = "x-small",
  attachmentItemCustomClass = null,
  extensionTagSize = "x-small",
  attachmentBorderRadius,
  customDeleteButtonStyle,
  deleteIconVariant,
  showDeleteButtonOnCreateMode,
  attachmentSize,
  setEditAttachmentModal,
  isWorkbook,
  setWorkbookMode,
  noteContainerStyle,
  showAttachmentCounterTag,
  removeAttachmentStyle = false,
  isAttachmentCountVisible = false,
  noteLinesContainerStyles,
  parentType,
  backgroundSize = "cover",
  itemStyles,
}) => {
  const isNewNoteUi = isNewNotesUi();
  const attachmentItemClass = classNames({
    [classes.attachmentItem]: true && !removeAttachmentStyle,
    [attachmentItemCustomClass]: !_.isNil(attachmentItemCustomClass),
  });

  const noteContainerStyleV2 = isNewNoteUi ? {} : { minHeight: "300px" };
  return (
    <div
      className={attachmentItemClass}
      key={_.get(item, "id", _.get(item, "url"))}
    >
      <MediaPlaceholder
        attachments={[item]}
        showVideoPlayer={false}
        resolutionMutliplier={3}
        imageMaxWidth={_.get(attachmentCardStyle, "width", 216)}
        imageHeight={_.get(attachmentCardStyle, "height", 162)}
        imageMaxHeight={_.get(attachmentCardStyle, "height", 162)}
        showDeleteIconOnTopCorner={showDeleteIcon}
        showIconCardsWithExtension={true}
        isAttachmentCreated={true}
        mode={mode}
        containerStyle={{
          width: _.get(attachmentCardStyle, "width", 216),
          minHeight: _.get(attachmentCardStyle, "height", 162),
          maxHeight: _.get(attachmentCardStyle, "height", 162),
          overflow: "visible",
          marginTop: showDeleteIcon
            ? removeAttachmentStyle
              ? "0px"
              : "6px"
            : removeAttachmentStyle
            ? "0px"
            : "3px",
        }}
        itemStyles={{
          border: `1px solid ${colors.borderSubtle}`,
          borderRadius: attachmentBorderRadius,
          ...itemStyles,
        }}
        noteContainerStyle={{
          ...noteContainerStyleV2,
          ...noteContainerStyle,
        }}
        showOverlayIcons={false}
        deleteAttachment={deleteAttachment}
        onClickMedia={
          shouldClickOnMedia
            ? e => onClickMedia({ event: e.event, attachmentIndex: index })
            : () => {}
        }
        extensionTagSize={extensionTagSize}
        showBorderOnHover={true}
        showExtensionOnCornerByHover={true}
        showMiddleContainerIcons={_.get(item, "type") == "VIDEO"}
        cardType={cardType}
        deleteButtonVariant={deleteButtonVariant}
        customDeleteButtonStyle={customDeleteButtonStyle}
        deleteIconVariant={deleteIconVariant}
        showDeleteButtonOnCreateMode={showDeleteButtonOnCreateMode}
        attachmentSize={attachmentSize}
        attachmentIndex={index}
        setEditAttachmentModal={setEditAttachmentModal}
        isWorkbook={isWorkbook}
        setWorkbookMode={setWorkbookMode}
        showAttachmentCounterTag={showAttachmentCounterTag}
        removeAttachmentStyle={removeAttachmentStyle}
        isAttachmentCountVisible={isAttachmentCountVisible}
        noteLinesContainerStyles={noteLinesContainerStyles}
        parentType={parentType}
        backgroundSize={backgroundSize}
      />
    </div>
  );
};

const MediaModalWrapper = ({
  attachments,
  toggleMediaModal,
  currentAttachmentIndex,
  post,
  canCreateComment,
  onPostActionClick,
  showTheatreViewByParent = false,
  t,
  canDownloadMedia = true,
  postIdFromParent,
  hideViews,
  hideLike,
  hideComments,
  cardType,
  canEditOrDelete,
  hideMoveToDraftOption,
  defaultAccodianExpanded,
  postRatedLearningGoalsDetails,
  taggedStudents,
  isProjectPostCard = false,
  canAddComments = true,
  mode = "view",
  onDeleteMedia,
  showDeleteAttachmentIcon,
  showEditIcon,
  setWorkbookMode,
  hasManageAccess = true,
  backgroundSize = "cover",
}) => {
  const isStudentResponse = !_.isNil(
    _.find(
      _.get(post, "items", []),
      item => _.get(item, "itemType", "") === "STUDENT_ASSIGNMENT"
    )
  );
  return showTheatreViewByParent ? (
    showNewTheatreMode() ? (
      isStudentResponse ? null : (
        <TheatreModeV2
          mediaAttachments={{ attachments: attachments }}
          activeAttachmentIndex={currentAttachmentIndex}
          toggleTheatreMode={toggleMediaModal}
          iframeIdSelector={"workbook-iframe-dp-journal"}
          onDiscardDirectly={() => toggleMediaModal(false)}
          canDownloadMedia={canDownloadMedia}
          postRatedLearningGoalsDetails={postRatedLearningGoalsDetails}
          taggedStudents={taggedStudents}
          showDeleteAttachmentIcon={showDeleteAttachmentIcon}
          showEditIcon={showEditIcon}
          onDeleteMedia={onDeleteMedia}
          setWorkbookMode={setWorkbookMode}
          sidePaneContent={
            _.isNil(post) || _.isEmpty(post) ? null : (
              // PostDetail will receive setTheatreAttachmentIndex(index), theatreActiveAttachmentIndex, setTheatreAttachmentById({id, type}) and theatreActiveAttachmentId as a props.
              <PostDetail
                postId={
                  !_.isNil(postIdFromParent) ? postIdFromParent : post?.id
                }
                onCloseClick={() => toggleMediaModal(false)}
                showComment={false} // false to not show comments screen initially
                customDetailText={t("common:view_with_label_lowercase", {
                  label: t("common:post"),
                })}
                isRightPaneChat={true}
                mediaMaxHeight={480}
                canCreateComment={canCreateComment}
                isSidePaneContent={true}
                showCloseBtn={false}
                showCommentBackButton={true}
                showAttachmentAsMediaCard={true}
                onPostActionClick={onPostActionClick}
                hideViews={hideViews}
                hideLike={hideLike}
                hideComments={hideComments}
                cardType={cardType}
                canEditOrDelete={canEditOrDelete}
                hideMoveToDraftOption={hideMoveToDraftOption}
                defaultAccodianExpanded={defaultAccodianExpanded}
                isProjectPostCard={isProjectPostCard}
                canAddComments={canAddComments}
                hasManageAccess={hasManageAccess}
              />
            )
          }
        />
      )
    ) : (
      <div>
        <MediaModal
          toggleMediaModal={toggleMediaModal}
          attachments={[attachments[currentAttachmentIndex]]}
          activeIndex={0}
          onWorkbookUpdateSuccessfully={() => toggleMediaModal(false)}
          videoAutoPlayOnClick={true}
          showDownloadVideoButton={true}
        />
      </div>
    )
  ) : null;
};

const MultipleAttachmentsSlider = props => {
  const {
    listContainerStyles = {},
    attachments = {},
    deleteAttachment,
    slidesToShow,
    slidesToScroll,
    showDeleteIcon = false,
    mode = "view",
    beforeChange,
    shouldClickOnMedia = true,
    responsiveSettings = [],
    post = {},
    canCreateComment = true,
    onPostActionClick,
    showAttachmentAsMediaCard = false,
    theatreActiveAttachmentId,
    setTheatreAttachmentIndex,
    isSidePaneContent,
    showTheatreViewByParent = false,
    setShowTheatreViewInParent,
    t,
    setRefetchComment = () => {},
    onCloseTheatreMode,
    cardType,
    showFullWidthSingleAttachment,
    showDots = false,
    attachmentCardStyle = {},
    listContainerClass = "",
    deleteButtonVariant = "x-small",
    attachmentItemCustomClass = null,
    extensionTagSize,
    showAttachmentsUsingScrollableCarousel = false,
    attachmentBorderRadius = "8px",
    canDownloadMedia = true,
    postIdFromParent,
    hideComments,
    hideViews,
    hideLike,
    canEditOrDelete,
    hideMoveToDraftOption,
    defaultAccodianExpanded,
    customDeleteButtonStyle,
    deleteIconVariant,
    postRatedLearningGoalsDetails,
    taggedStudents,
    showDeleteButtonOnCreateMode,
    setEditAttachmentModal,
    isWorkbook,
    setWorkbookMode,
    noteContainerStyle,
    isProjectPostCard = false,
    canAddComments = true,
    removeAttachmentStyle = false,
    showControlDots = true,
    onDeleteMedia,
    showDeleteAttachmentIcon,
    showEditIcon,
    carouselWrapperStyle,
    showAttachmentCounterTag = false,
    onCloseClick,
    showActiveControlDotValue = false,
    scrollableCarouselWrapperCustomClass = null,
    noteLinesContainerStyles = {},
    hasManageAccess = true,
    isUpdateSmallCard = false,
    parentType,
    isNote = false,
    backgroundSize = "cover",
    itemStyles = {},
  } = props;
  const [currentAttachmentIndex, setCurrentAttachmentIndex] = useState(0);
  const [isAttachmentCountVisible, setAttachmentCountVisible] = useState(false);
  const onClickMedia = ({ event, attachmentIndex } = {}) => {
    if (event && event.stopPropagation) event.stopPropagation();

    if (
      showTheatreViewByParent == false &&
      !isSidePaneContent &&
      _.isFunction(setShowTheatreViewInParent)
    )
      setShowTheatreViewInParent(true);

    if (
      showNewTheatreMode() &&
      isSidePaneContent &&
      _.isFunction(setTheatreAttachmentIndex)
    ) {
      setTheatreAttachmentIndex(attachmentIndex);
    } else {
      setCurrentAttachmentIndex(attachmentIndex);
    }
  };

  const onToggleMediaModal = () => {
    if (_.isFunction(onCloseClick)) {
      onCloseClick();
    }

    if (showTheatreViewByParent) setRefetchComment(true);
    if (
      showTheatreViewByParent == true &&
      _.isFunction(setShowTheatreViewInParent)
    )
      setShowTheatreViewInParent(false);

    if (_.isFunction(onCloseTheatreMode)) onCloseTheatreMode();
  };

  const scrollableCarouselWrapperClass = classNames({
    [classes.scrollableCarouselWrapper]: true,
    [scrollableCarouselWrapperCustomClass]: !_.isNil(
      scrollableCarouselWrapperCustomClass
    ),
  });
  const isNewNoteUi = isNewNotesUi();
  const noteContainerStyleV2 = isNewNoteUi
    ? { minHeight: "80px", maxHeight: "450px", height: "auto" }
    : { minHeight: "300px" };

  const containerStyle = {
    width: "100%",
    aspectRatio: "4/3",
    height: "auto",
    overflow: "visible",
    marginTop: showDeleteIcon ? "6px" : isUpdateSmallCard ? "0px" : "3px",
  };
  const containerStyleV2 = isNote
    ? isNewNoteUi
      ? { width: "100%" }
      : containerStyle
    : containerStyle;

  return (
    <div style={listContainerStyles} className={listContainerClass}>
      <MediaModalWrapper
        attachments={attachments}
        toggleMediaModal={onToggleMediaModal}
        currentAttachmentIndex={currentAttachmentIndex}
        post={post}
        canCreateComment={canCreateComment}
        onPostActionClick={onPostActionClick}
        t={t}
        showTheatreViewByParent={showTheatreViewByParent}
        canDownloadMedia={canDownloadMedia}
        postIdFromParent={postIdFromParent}
        hideViews={hideViews}
        hideLike={hideLike}
        hideComments={hideComments}
        cardType={cardType}
        canEditOrDelete={canEditOrDelete}
        hideMoveToDraftOption={hideMoveToDraftOption}
        defaultAccodianExpanded={defaultAccodianExpanded}
        postRatedLearningGoalsDetails={postRatedLearningGoalsDetails}
        taggedStudents={taggedStudents}
        isProjectPostCard={isProjectPostCard}
        canAddComments={canAddComments}
        mode={mode}
        onDeleteMedia={onDeleteMedia}
        showDeleteAttachmentIcon={showDeleteAttachmentIcon}
        showEditIcon={showEditIcon}
        setWorkbookMode={setWorkbookMode}
        hasManageAccess={hasManageAccess}
      />
      {showAttachmentAsMediaCard == false ? (
        <div>
          <div>
            {showFullWidthSingleAttachment &&
            _.get(attachments, "length", 0) === 1 ? (
              <MediaPlaceholder
                attachments={[attachments[0]]}
                showVideoPlayer={false}
                resolutionMutliplier={3}
                imageMaxWidth={1008}
                showDeleteIconOnTopCorner={showDeleteIcon}
                showIconCardsWithExtension={true}
                isAttachmentCreated={true}
                mode={mode}
                containerStyle={containerStyleV2}
                itemStyles={{
                  border: `1px solid ${colors.borderSubtle}`,
                  borderRadius: "8px",
                  ...itemStyles,
                }}
                showOverlayIcons={false}
                deleteAttachment={deleteAttachment}
                onClickMedia={
                  shouldClickOnMedia
                    ? e => onClickMedia({ event: e.event, attachmentIndex: 0 })
                    : () => {}
                }
                fileIconSize={"x-small"}
                extensionTextStyle={{ fontSize: "1.4rem", marginTop: "4px" }}
                showBorderOnHover={true}
                showExtensionOnCornerByHover={true}
                showMiddleContainerIcons={
                  _.get(attachments[0], "type") == "VIDEO"
                }
                cardType={cardType}
                customDeleteButtonStyle={customDeleteButtonStyle}
                deleteIconVariant={deleteIconVariant}
                showDeleteButtonOnCreateMode={showDeleteButtonOnCreateMode}
                attachmentSize={_.size(attachments)}
                setEditAttachmentModal={setEditAttachmentModal}
                isWorkbook={isWorkbook}
                setWorkbookMode={setWorkbookMode}
                removeAttachmentStyle={removeAttachmentStyle}
                noteLinesContainerStyles={noteLinesContainerStyles}
                noteContainerStyle={{
                  ...noteContainerStyleV2,
                }}
              />
            ) : (
              <div>
                {showAttachmentsUsingScrollableCarousel ? (
                  <ConditionalWrapper
                    condition={_.size(attachments) > 1}
                    wrapper={
                      <ScrollableCarousel
                        showControlDots={showControlDots}
                        scrollAmount={
                          _.get(attachmentCardStyle, "width", 216) + 16
                        } // card width + padding
                        carouselWrapperStyle={carouselWrapperStyle}
                        setAttachmentCountVisible={setAttachmentCountVisible}
                        isAttachmentCountVisible={isAttachmentCountVisible}
                        activeControlDotValue={_.size(attachments)}
                        showActiveControlDot={showActiveControlDotValue}
                      />
                    }
                    type={"wrapperAsElement"}
                  >
                    <div className={scrollableCarouselWrapperClass}>
                      {_.map(attachments, (item, index) => {
                        return renderAttachment({
                          item,
                          index,
                          deleteAttachment,
                          showDeleteIcon,
                          mode,
                          shouldClickOnMedia,
                          onClickMedia,
                          attachmentCardStyle,
                          deleteButtonVariant,
                          attachmentItemCustomClass,
                          extensionTagSize,
                          attachmentBorderRadius,
                          customDeleteButtonStyle,
                          deleteIconVariant,
                          showDeleteButtonOnCreateMode,
                          attachmentSize: _.size(attachments),
                          setEditAttachmentModal,
                          isWorkbook,
                          setWorkbookMode,
                          noteContainerStyle,
                          removeAttachmentStyle,
                          showAttachmentCounterTag,
                          isAttachmentCountVisible,
                          noteLinesContainerStyles,
                          parentType,
                          backgroundSize,
                          itemStyles,
                        });
                      })}
                    </div>
                  </ConditionalWrapper>
                ) : (
                  <SlickSlider
                    items={attachments}
                    renderItem={data =>
                      renderAttachment({
                        item: data.item,
                        index: data.index,
                        deleteAttachment,
                        showDeleteIcon,
                        mode,
                        shouldClickOnMedia,
                        onClickMedia,
                        cardType,
                        attachmentCardStyle,
                        deleteButtonVariant,
                        attachmentItemCustomClass,
                        extensionTagSize,
                        attachmentBorderRadius,
                        customDeleteButtonStyle,
                        deleteIconVariant,
                        showDeleteButtonOnCreateMode,
                        setEditAttachmentModal,
                        isWorkbook,
                        setWorkbookMode,
                        noteContainerStyle,
                        removeAttachmentStyle,
                      })
                    }
                    variableWidth={true}
                    showDots={showDots}
                    slidesToShow={slidesToShow}
                    slidesToScroll={slidesToScroll}
                    swipeToSlide={true}
                    responsiveSettings={responsiveSettings}
                    beforeChange={beforeChange}
                    customPrevArrowStyle={{ left: "-16px", margin: "0" }}
                    customNextArrowStyle={{ margin: "0" }}
                  />
                )}
              </div>
            )}
          </div>
        </div>
      ) : (
        <div className={classes.attachmentMediaCardsContainer}>
          {_.map(attachments, (attachment, index) => {
            const attachmentType = _.get(attachment, "type", "FILE");
            const name = _.isEqual(attachmentType, "NOTE")
              ? _.get(attachment, "title", "untitled")
              : _.get(attachment, "name", "untitled");
            const mimeType = _.get(attachment, "mimeType", "");
            const thumbUrl =
              attachmentType == "IMAGE"
                ? _.get(attachment, "url", "")
                : _.get(attachment, "thumbUrl", "");
            const url = _.get(attachment, "url", "");
            return (
              <div
                key={`ATTACHMENT_${_.get(attachment, "id", "")}`}
                style={{ marginBottom: "8px" }}
              >
                <MediaCard
                  cardType="medium"
                  name={name}
                  type={attachmentType}
                  mimeType={mimeType}
                  thumbUrl={thumbUrl}
                  url={url}
                  showSubtext={true}
                  isActivated={
                    _.get(attachment, "id", "") == theatreActiveAttachmentId
                  }
                  onClick={
                    shouldClickOnMedia
                      ? e => onClickMedia({ event: e, attachmentIndex: index })
                      : () => {}
                  }
                  style={{ marginBottom: "8px" }}
                />
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default compose(I18nHOC({ resource: ["common", "journal"] }))(
  MultipleAttachmentsSlider
);
